
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters("bedbuilder", ["showOptionsModalOpen"]),
    ...mapState("bedbuilder", [
      "activeOptions",
      "activeImages",
      "headboardDrawers",
    ]),

    mattressImage() {
      const materialImages = {
        Timber: this.activeImages.timberMattress,
        Upholstered: this.activeImages.upholsteredMattress,
      };
      return materialImages[this.activeOptions.Material] || "";
    },

    hasDrawers() {
      const headboardName = this.activeOptions.Headboard;
      return this.headboardDrawers?.[headboardName] === true;
    },
  },
};
